var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle24Px = function SvgGoogle24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-24px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.18 1H3.82c-.935 0-1.692.777-1.692 1.737l.033 11h19.71v-11c0-.96-.756-1.737-1.691-1.737Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-24px_svg__b)",
    d: "M-.622 3.316h25.244v12.748H-.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.308 4.474H2.692C1.757 4.474 1 5.25 1 6.21c0 .08.006.16.016.237l1.112 7.289h19.744l1.113-7.289c.01-.078.015-.158.015-.237 0-.96-.757-1.737-1.692-1.737Z",
    fill: "#3367D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.308 4.474H2.692C1.757 4.474 1 5.25 1 6.21c0 .08.006.16.016.237l1.112 7.289h19.744l1.113-7.289c.01-.078.015-.158.015-.237 0-.96-.757-1.737-1.692-1.737Z",
    fill: "#2A56C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.432 21.143-.56-7.406H2.128l-.56 7.406c-.002.04-.004.08-.004.12 0 .96.757 1.737 1.692 1.737h17.488c.935 0 1.692-.777 1.692-1.737 0-.04-.002-.08-.004-.12Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.128 13.737 11.154 23h11.282v-9.263H2.128Z",
    fill: "url(#google-24px_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.692 4.618h18.616c.915 0 1.66.747 1.69 1.68L23 6.21c0-.96-.757-1.736-1.692-1.736H2.692C1.757 4.474 1 5.25 1 6.21c0 .03.001.058.003.087.03-.932.774-1.679 1.69-1.679Z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.744 22.855H3.256c-.915 0-1.66-.747-1.69-1.679a1.772 1.772 0 0 0-.002.087c0 .96.757 1.737 1.692 1.737h17.488c.935 0 1.692-.777 1.692-1.737l-.003-.087c-.03.932-.774 1.68-1.69 1.68Z",
    fill: "#1A237E",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.18 1H3.82c-.935 0-1.692.777-1.692 1.737v.137c.004-.955.76-1.73 1.693-1.73H20.18c.934 0 1.692.778 1.692 1.738v-.145c0-.96-.758-1.737-1.692-1.737Z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.344 13.613c.642-.273 1.468-.996 1.468-2.086 0-1.68-1.05-2.711-2.82-2.711-1.577 0-2.847 1.06-2.87 2.605h1.145c.017-.903.612-1.645 1.723-1.645 1.07 0 1.675.571 1.675 1.725 0 1.153-.86 1.686-1.91 1.686h-.8v.92h.8c1.543 0 2.05.823 2.05 1.777 0 1.247-.739 1.823-1.809 1.823-.932 0-1.781-.51-1.806-1.653H6.036c.05 1.84 1.558 2.606 2.96 2.606 1.62 0 2.955-.969 2.955-2.803.002-1.479-1.024-2.07-1.607-2.244Zm6.547-4.797-3.34 1.23v1.106l2.398-.822v8.328h1.128V8.816h-.186Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.344 13.613c.642-.273 1.468-.996 1.468-2.086 0-1.68-1.05-2.711-2.82-2.711-1.577 0-2.847 1.06-2.87 2.605h1.145c.017-.903.612-1.645 1.723-1.645 1.07 0 1.675.571 1.675 1.725 0 1.153-.86 1.686-1.91 1.686h-.8v.92h.8c1.543 0 2.05.823 2.05 1.777 0 1.247-.739 1.823-1.809 1.823-.932 0-1.781-.51-1.806-1.653H6.036c.05 1.84 1.558 2.606 2.96 2.606 1.62 0 2.955-.969 2.955-2.803.002-1.479-1.024-2.07-1.607-2.244Zm6.547-4.797-3.34 1.23v1.106l2.398-.822v8.328h1.128V8.816h-.186Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.344 13.613c.642-.273 1.468-.996 1.468-2.086 0-1.68-1.05-2.711-2.82-2.711-1.577 0-2.847 1.06-2.87 2.605h1.145c.017-.903.612-1.645 1.723-1.645 1.07 0 1.675.571 1.675 1.725 0 1.153-.86 1.686-1.91 1.686h-.8v.92h.8c1.543 0 2.05.823 2.05 1.777 0 1.247-.739 1.823-1.809 1.823-.932 0-1.781-.51-1.806-1.653H6.036c.05 1.84 1.558 2.606 2.96 2.606 1.62 0 2.955-.969 2.955-2.803.002-1.479-1.024-2.07-1.607-2.244Zm6.547-4.797-3.34 1.23v1.106l2.398-.822v8.328h1.128V8.816h-.186Z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.136 4.474 6.043 3.35l1.196-1.227 2.292 2.35H7.136Z",
    fill: "url(#google-24px_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.641 3.605a.858.858 0 0 0 .846-.868.858.858 0 0 0-.846-.869.858.858 0 0 0-.846.869c0 .48.379.868.846.868Z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.641 2.014c.444 0 .807.35.842.796a.858.858 0 0 0-.842-.94.858.858 0 0 0-.842.94.853.853 0 0 1 .842-.796Z",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.483 2.81a.854.854 0 0 1-.842.795.854.854 0 0 1-.842-.796.858.858 0 0 0 .842.94.858.858 0 0 0 .842-.94Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.013 13.737H1.987v.145h20.026v-.145Z",
    fill: "#fff",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.013 13.592H1.987v.145h20.026v-.145Z",
    fill: "#1A237E",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.854 4.474 16.76 3.35l1.196-1.227 1.727 2.35h-1.83Z",
    fill: "url(#google-24px_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.359 3.605a.858.858 0 0 0 .846-.868.858.858 0 0 0-.846-.869.857.857 0 0 0-.846.869c0 .48.378.868.846.868Z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.359 2.013c.444 0 .806.35.842.796.001-.024.004-.048.004-.072 0-.48-.38-.869-.846-.869a.858.858 0 0 0-.842.941.853.853 0 0 1 .842-.796Z",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 2.81a.854.854 0 0 1-.841.795.854.854 0 0 1-.842-.796c-.002.025-.004.048-.004.073 0 .479.38.868.846.868a.858.858 0 0 0 .842-.94Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.21c0-.755-.471-1.396-1.128-1.635V2.737c0-.96-.758-1.737-1.692-1.737H3.82c-.934 0-1.692.777-1.692 1.737l.004 1.835a1.734 1.734 0 0 0-1.116 1.876l1.112 7.289-.56 7.406c-.002.04-.004.08-.004.12 0 .96.757 1.737 1.692 1.737h17.488c.935 0 1.692-.777 1.692-1.737 0-.04-.002-.08-.004-.12l-.56-7.406 1.113-7.29c.01-.076.015-.155.015-.236Z",
    fill: "url(#google-24px_svg__f)",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-24px_svg__c",
    x1: 7.249,
    y1: 8.574,
    x2: 16.736,
    y2: 17.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-24px_svg__d",
    x1: 6.627,
    y1: 2.725,
    x2: 7.752,
    y2: 3.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-24px_svg__e",
    x1: 17.345,
    y1: 2.727,
    x2: 18.332,
    y2: 3.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "google-24px_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.2395 0 0 28.9826 2.51 1.486)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google-24px_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "google-24px_svg__b",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-24px_svg__g"
  })), /*#__PURE__*/React.createElement("image", {
    id: "google-24px_svg__g",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAvQAAAF0CAYAAABMhK1TAAAACXBIWXMAAAp1AAAKdQFKJd39AAAA"
  }))));
};
export default SvgGoogle24Px;